<template>
  <div class="notice">
    <el-row type="flex" align="start" class="list-container">
      <el-col class="item-box left" :span="2" :offset="1">
        <h4 class="list-title">
          <el-row type="flex" align="middle" justify="center">
            <svg
              t="1596503621223"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1827"
              width="20"
              height="20"
            >
              <path
                d="M84.960699 390.521106l888.36099-135.63901-719.930132 238.486172zM257.863173 503.802038l719.930131-238.486172-629.007278 287.673945 10.43377 219.10917z"
                fill="#030000"
                p-id="1828"
              />
              <path
                d="M375.615721 812.343523l-11.924309-219.109171 156.50655 99.866085zM634.969432 746.759825l-119.243086-77.508005-156.50655-99.866085 629.007278-287.673945z"
                fill="#030000"
                p-id="1829"
              />
            </svg>
            消息中心
          </el-row>
        </h4>
        <div
          class="list-item"
          :class="{ active: pageType === 'news' }"
          @click="pageType = 'news'"
        >平台消息</div>
        <div
          class="list-item"
          :class="{ active: pageType === 'notice' }"
          @click="pageType = 'notice'"
        >平台公告</div>
      </el-col>
      <el-col class="item-box right" :span="14" :offset="1">
        <div v-show="pageType === 'news'" style="height:calc(100% - 40px);">
          <el-row class="title li" type="flex" justify="space-between" align="middle">
            <div>平台消息</div>
            <div class="tips" @click="allReadInfo('news')">一键已读</div>
          </el-row>
          <el-scrollbar class="box-item" wrap-class="scrollbar-wrapper">
            <div
              class="li"
              :class="{ 'no-read': item.whetherToRead === 2 }"
              v-for="item in listNews"
              :key="item.id"
              @click="seeNewsDetail(item)"
            >
              <el-row type="flex" justify="space-between" align="middle">
                <div>
                  <span class="li-title">{{ item.title }}</span>
                  <span class="li-date">{{ item.createTime }}</span>
                </div>
              </el-row>
              <div v-html="item.content"></div>
            </div>
          </el-scrollbar>
        </div>
        <div v-show="pageType === 'notice'" style="height:calc(100% - 40px);">
          <el-row class="title li" type="flex" justify="space-between" align="middle">
            <div>平台公告</div>
            <div class="tips" @click="allReadInfo('notice')">一键已读</div>
          </el-row>
          <el-scrollbar class="box-item" wrap-class="scrollbar-wrapper">
            <el-row
              type="flex"
              justify="space-between"
              align="middle"
              class="li"
              :class="{ 'no-read': item.whetherToRead === 2 }"
              v-for="item in listNotice"
              :key="item.id"
            >
              <div>
                <span class="li-title">{{ item.title }}</span>
                <span class="li-date">{{ item.createTime }}</span>
              </div>
              <div>
                <el-button type="text" @click="seeDetail(item)">查看详情</el-button>
              </div>
            </el-row>
          </el-scrollbar>
        </div>
        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[20, 50, 100, 200, 300]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      title="公告详情"
      :visible.sync="dialogDetailVisible"
      width="60%"
      @close="dialogClose"
      class="detail-container"
      top="4vh"
    >
      <h3 class="title">{{ detailData.title }}</h3>
      <p class="notice-content" v-html="detailData.content"></p>
      <el-row v-if="Object.keys(detailData).length && detailData.accessoryList.length">
        <div>附件：</div>
        <el-col :span="12">
          <div v-for="(item, index) in detailData.accessoryList" :key="item.accessoryId">
            <el-row type="flex" align="middle">
              <div>{{ index + 1 + ". " + item.accessoryName }}</div>
              <el-button type="text" @click="downloadFile(item)">下载</el-button>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Baseurl, ajaxPost } from "../../api/api/api";
export default {
  name: "notice",
  data() {
    return {
      pageType: "",
      page: 1,
      size: 20,
      total: 0,
      UserInfo: {},
      listNews: [],
      listNotice: [],
      dialogDetailVisible: false,
      detailData: {},
      fullScreenLoading: null
    };
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem("role"));
    if (this.$route.params.pageType) {
      this.pageType = this.$route.params.pageType;
    }
    this.getList();
  },
  watch: {
    pageType: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.page = 1;
          this.size = 20;
          this.total = 0;
          this.getList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let API = "";
      let paramsData = {
        page: this.page,
        size: this.size,
      };
      if (this.pageType === "notice") {
        API = Baseurl + "announcementController/selectAnnouncementInfoReleased";
        paramsData.readRid = this.UserInfo.rid;
      } else if (this.pageType === "news") {
        API = Baseurl + "platformNewsController/selectPlatformNews";
        paramsData.rid = this.UserInfo.rid;
      }
      this.fullScreenLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading'
      });
      ajaxPost(API, paramsData).then((res) => {
        this.fullScreenLoading.close()
        const { code, data } = res.data;
        if (code === 200) {
          this.total = data.total;
          this.pageType === "notice"
            ? (this.listNotice = data.list)
            : (this.listNews = data.list);
        }
      });
    },
    seeDetail(item) {
      this.detailData = item;
      this.dialogDetailVisible = true;
      if (item.whetherToRead === 1) return;
      const ids = [item.id];
      this.readInfo(ids);
    },
    seeNewsDetail(item) {
      if (item.whetherToRead === 1) return;
      const ids = [item.id];
      this.readNews(ids);
    },
    dialogClose() {
      this.detailData = {};
    },
    downloadFile(item) {
      // const AElement = document.createElement("a");
      // AElement.target="_blank"
      // AElement.href = item.accessoryUrl;
      // AElement.download = item.accessoryName;
      // AElement.click();
      // this.$message.success("正在下载...");
      window.open(item.accessoryUrl);
    },
    readInfo(ids) {
      const API = Baseurl + "announcementController/readAnnouncementInfo";
      const paramsData = {
        readRid: this.UserInfo.rid,
        ids,
      };
      ajaxPost(API, paramsData).then((res) => {
        this.fullScreenLoading.close()
        const { code } = res.data;
        if (code === 200) {
          ids.forEach((item) => {
            this.listNotice.find((key) => key.id === item).whetherToRead = 1;
            this.$parent.getUnreadMsgNum()
          });
        }
      });
    },
    readNews(ids) {
      const API = Baseurl + "platformNewsController/readPlatformNews";
      const paramsData = {
        rid: this.UserInfo.rid,
        ids,
      };
      ajaxPost(API, paramsData).then((res) => {
        this.fullScreenLoading.close()
        const { code } = res.data;
        if (code === 200) {
          ids.forEach((item) => {
            this.listNews.find((key) => key.id === item).whetherToRead = 1;
            this.$parent.getUnreadMsgNum()
          });
        }
      });
    },
    allReadInfo(type) {
      const arrList = type === "notice" ? "listNotice" : "listNews";
      const ids = this[arrList]
        .filter((item) => item.whetherToRead === 2)
        .map((item) => item.id);
      if (!ids.length) return;
      this.fullScreenLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading'
      });
      type === "notice" ? this.readInfo(ids) : this.readNews(ids);
    },
  },
};
</script>

<style lang="scss" scoped>
.notice {
  width: 98%;
  height: 100%;
  overflow: hidden;
  .list-container {
    height: 100%;
    .item-box {
      box-sizing: border-box;
      &.left {
        border-radius: 4px;
        padding: 10px;
        height: 200px;
        border: 1px solid #999;
        .list-title {
          background: #dee9f6;
          margin-bottom: 34px;
          line-height: 2.5em;
        }
        .list-item {
          text-align: center;
          cursor: pointer;
          margin-bottom: 20px;
          position: relative;

          &::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 4px;
            background: #000;
            border-radius: 50%;
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            left: 20px;
          }
          &.active {
            color: #409eff;
            &::before {
              background: #409eff;
            }
          }
        }
      }
      &.right {
        .li {
          width: 98.8%;
          background: #fff;
          padding: 10px;
          border: 1px solid #999;
          border-radius: 4px;
          overflow: hidden;
          box-sizing: border-box;
          &.no-read {
            border: 1px solid red;
          }
          .li-title {
            font-weight: bold;
          }
          .li-date {
            margin: 0 10px;
          }
          &:not([class*="title"]) {
            margin-top: 20px;
          }
          &.title .tips {
            color: #999;
            cursor: pointer;
            user-select: none;
          }
        }
        .box-item {
          height: calc(100% - 41px);
        }
        .pagination-container {
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .detail-container {
    .title {
      text-align: center;
      margin-bottom: 10px;
    }
  }
  ::v-deep {
    .notice-content {
      img {
        max-width: 100%;
      }
    }
  }
}
</style>
<style>
.scrollbar-wrapper {
  overflow-x: hidden !important;
}
</style>
